import { ConfigOrder } from '../services/config-orders.service';

const B2B_TYPE_PREFIX = 'B2B_';

/** Tipo de OS dedicado ao fluxo B2B (triagem / orçamento / execução). */
export function isB2bConfigOrder(
  config: { typeOS?: string | null } | null | undefined
): boolean {
  return (config?.typeOS || '').trim().toUpperCase().startsWith(B2B_TYPE_PREFIX);
}

/**
 * Une os ConfigOrders do JWT com os tipos B2B ativos.
 * Orçamentos B2B criam OS com TypeOS B2B_*; sem isso a listagem ignora essas OS
 * quando o perfil ainda só tem "Manutenção" no token.
 */
export function mergeAccessibleConfigOrderIds(
  tokenIds: number[],
  allConfigs: ConfigOrder[]
): number[] {
  const fromToken = [...new Set((tokenIds || []).filter((id) => id > 0))];

  const b2bIds = (allConfigs || [])
    .filter((c) => c.active !== false && isB2bConfigOrder(c))
    .map((c) => c.id!)
    .filter((id): id is number => !!id && id > 0);

  if (fromToken.length === 0 && b2bIds.length === 0) {
    return [];
  }

  return [...new Set([...fromToken, ...b2bIds])];
}

/** Opções de filtro/listagem respeitando token + tipos B2B. */
export function filterAccessibleConfigOrders(
  allConfigs: ConfigOrder[],
  accessibleIds: number[]
): ConfigOrder[] {
  if (!accessibleIds.length) {
    return [];
  }
  return (allConfigs || []).filter(
    (c) => c.active !== false && accessibleIds.includes(c.id!)
  );
}
